import { render, staticRenderFns } from "./PackageInfo.vue?vue&type=template&id=dca4737a"
import script from "./PackageInfo.vue?vue&type=script&lang=js"
export * from "./PackageInfo.vue?vue&type=script&lang=js"
import style0 from "./PackageInfo.vue?vue&type=style&index=0&id=dca4737a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports